import React from 'react';

const Table = ({ data, columns }) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full bg-[#252526] border border-[#3E3E42]">
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th
                                key={index}
                                className="px-6 py-3 text-left text-xs font-medium text-[#CCCCCC] uppercase tracking-wider border-b border-[#3E3E42]"
                            >
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-[#3E3E42]">
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex} className="hover:bg-[#2D2D30]">
                            {columns.map((column, colIndex) => (
                                <td
                                    key={colIndex}
                                    className="px-6 py-4 whitespace-nowrap text-sm text-[#CCCCCC]"
                                >
                                    {column.render
                                        ? column.render(row[column.accessor], row)
                                        : row[column.accessor]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table; 